import React from 'react';
import {Divider} from '@mui/material';
import translate from '@/utils/translate';
import PlatformSection from './PlatformSection';
import TargetAudienceSection from './TargetAudienceSection';

interface AudienceChannelsSectionProps {
  testID?: string;
  selectedPlatforms: string[];
  onPlatformSelect: (platform: string) => void;
  selectedAudiences: string[];
  onAudienceSelect: (audience: string) => void;
  // Section-specific labels (optional with defaults)
  platformLabel?: string;
  audienceLabel?: string;
}

function AudienceChannelsSection({
  testID = 'audience-channels-section',
  selectedPlatforms,
  onPlatformSelect,
  selectedAudiences,
  onAudienceSelect,
  platformLabel = translate('Platform'),
  audienceLabel = translate('Target Audience'),
}: AudienceChannelsSectionProps) {
  return (
    <>
      <PlatformSection
        testID={`${testID}-platform`}
        selectedPlatforms={selectedPlatforms}
        onPlatformSelect={onPlatformSelect}
        label={platformLabel}
      />

      <Divider sx={{marginTop: '24px', marginBottom: '16px', width: '100%'}} />

      <TargetAudienceSection
        testID={`${testID}-audience`}
        selectedAudiences={selectedAudiences}
        onAudienceSelect={onAudienceSelect}
        label={audienceLabel}
      />
    </>
  );
}

export default AudienceChannelsSection;
